import { nearestStrike } from './gammaLevels';

function finiteNumber(value) {
  if (value == null || value === '') return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

export function esAdjustedPrice(spxChainPrice, spxSpot, esSpot) {
  const price = finiteNumber(spxChainPrice);
  const spx = finiteNumber(spxSpot);
  const es = finiteNumber(esSpot);
  if (price == null || spx == null || es == null) return null;
  return price + (es - spx);
}

export function esAdjustedStrike(spxChainPrice, spxSpot, esSpot, availableStrikes = null, step = 5) {
  const adjusted = esAdjustedPrice(spxChainPrice, spxSpot, esSpot);
  if (adjusted == null) return null;
  if (Array.isArray(availableStrikes) && availableStrikes.length > 0) {
    return nearestStrike(availableStrikes, adjusted);
  }
  const strikeStep = finiteNumber(step);
  if (strikeStep == null || strikeStep <= 0) return null;
  return Math.round(adjusted / strikeStep) * strikeStep;
}

export function latestIndexSpot(indexData = {}, aggregationState = {}, symbol = 'ES') {
  const cleanSymbol = String(symbol || '').replace(/^I:/, '');
  const liveClose = finiteNumber(aggregationState?.[cleanSymbol]?.close);
  if (liveClose != null) return liveClose;
  const bars = indexData?.[cleanSymbol];
  if (!Array.isArray(bars) || bars.length === 0) return null;
  return finiteNumber(bars[bars.length - 1]?.close);
}

export function esBasis(spxSpot, esSpot) {
  const spx = finiteNumber(spxSpot);
  const es = finiteNumber(esSpot);
  if (spx == null || es == null) return null;
  return es - spx;
}
